import React from 'react';
import { Button } from './Button';
import { ShoppingCartIcon } from 'lucide-react';
export interface ProductCardProps {
  title: string;
  price: string;
  category: string;
  image?: string;
  isNew?: boolean;
  onAddToCart?: () => void;
}
export function ProductCard({
  title,
  price,
  category,
  image,
  isNew,
  onAddToCart
}: ProductCardProps) {
  return <div className={`group flex flex-col bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 ${isNew ? 'border-2 border-red-500' : 'border border-gray-200'}`} data-id="element-241">
      {/* Image Placeholder */}
      <a href="#product-gen3-efoot" className="relative aspect-square bg-gray-100 p-4 flex items-center justify-center overflow-hidden block hover:opacity-90 transition-opacity" data-id="element-242">
        {image ? <img src={image} alt={title} className="w-full h-full object-contain relative z-[1]" data-id="element-243" /> : <>
            <div className="absolute inset-0 bg-gradient-to-tr from-gray-200 to-gray-50 opacity-50" data-id="element-244"></div>
            <span className="relative text-gray-400 font-medium text-center px-4" data-id="element-245">
              {title} Image
            </span>
          </>}
        {isNew && <span className="absolute top-3 left-3 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider z-10" data-id="element-246">
            New
          </span>}
      </a>

      {/* Content */}
      <div className="p-5 flex flex-col flex-grow" data-id="element-247">
        <span className="text-xs text-blue-600 font-semibold uppercase tracking-wider mb-1" data-id="element-248">
          {category}
        </span>
        <a href="#product-gen3-efoot" data-id="element-249">
          <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 hover:text-red-600 transition-colors" data-id="element-250">
            {title}
          </h3>
        </a>
        <div className="mt-auto pt-4 flex items-center justify-between" data-id="element-251">
          <span className="text-xl font-extrabold text-gray-900" data-id="element-252">{price}</span>
          <a href="#product-gen3-efoot" data-id="element-253">
            <Button variant="primary" className="!py-2 !px-3" aria-label={`View ${title}`} data-id="element-254">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-255" />
            </Button>
          </a>
        </div>
      </div>
    </div>;
}